module.exports = __webpack_public_path__ + "img/battles.bdb2aa38.png";